import React, { useEffect, useState } from 'react';
interface SpinnerProps {
  class?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
  class: className = 'w-8 h-8 border-4 border-[var(--lifexlight)]',
}) => <div className={` rounded-full animate-spin border-t-transparent ${className ?? ''}`} />;

export const LoadingSpinner: React.FC = () => (
  <div className="fixed inset-0 flex items-center justify-center z-50 bg-transparent">
    <Spinner />
  </div>
);

export const LoadingPercentageBackdrop = () => {
  const [loadingPercentage, setLoadingPercentage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (loadingPercentage >= 98) {
        clearInterval(interval);
        setLoadingPercentage(98);
      } else {
        setLoadingPercentage(loadingPercentage + 8);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [loadingPercentage]);

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-opacity-50 backdrop-blur-md bg-black/10 z-50">
      <div className="text-[var(--lifexlight)] text-[24px] flex justify-center items-center flex-col">
        <div className="relative flex items-center justify-center">
          <Spinner class="w-16 h-16 border-4 border-[var(--lifexlight)]" />
          <div className="absolute inset-0 flex items-center justify-center text-[16px] text-[var(--lifexlight)]">
            {loadingPercentage > 100 ? 98 : loadingPercentage}%
          </div>
        </div>
        <p>Almost there!</p>
      </div>
    </div>
  );
};
